export default __webpack_public_path__ + "static/3-okanagan-label-2d17c7d3ae0c95d06b63366f6b593e92.svg";